module.exports = __webpack_public_path__ + "img/BahnBruecke_kl.a5743baa.jpg";